import { createSelector } from 'reselect';
import { subselect } from './root';
import { loadedDataSelector } from './loadedData';

const pointsSelector = createSelector(
  [loadedDataSelector],
  (loadedData) => loadedData && loadedData.points,
);

export const triviaPointsSelector = subselect(pointsSelector);
